import { useSources } from '#pplx/frontend/apps/ask/sources/hooks/useSources.js';
import { EMPTY_ARRAY } from '#pplx/frontend/common/defaults.js';
import { QSOURCE_SUGGESTIONS_PARAM } from '#pplx/frontend/components/utils/consts.js';
import { useSearchParams } from '#pplx/frontend/router/useSearchParams.js';
import { useMemo } from 'react';
/**
 * Reads source suggestions from the `qsource_suggestions` URL parameter.
 * These are sources that were requested via `qsources` but couldn't be
 * auto-selected because the user hasn't connected them yet.
 *
 * Connection status is resolved live — if the user connects a source after
 * the param was written, it will reflect the updated status.
 */
export function useUrlSourceSuggestions({ enabled = true, omittedSources = EMPTY_ARRAY, productSurface, }) {
    const searchParams = useSearchParams();
    const raw = searchParams.get(QSOURCE_SUGGESTIONS_PARAM);
    const { isSourceConnected } = useSources({ enabled, omittedSources, productSurface });
    const suggestions = useMemo(() => {
        if (!enabled || !raw) {
            return [];
        }
        const sourceIds = raw
            .split(',')
            .map((s) => s.trim())
            .filter((s) => s && !omittedSources.includes(s));
        return sourceIds.map((source) => ({
            source,
            connected: isSourceConnected(source),
        }));
    }, [enabled, raw, omittedSources, isSourceConnected]);
    return useMemo(() => ({ suggestions }), [suggestions]);
}
//# sourceMappingURL=useUrlSourceSuggestions.js.map